<template>
    <div class="progress">
        <div class="countDownBar">
            <span class="countDownSpan" v-if="nodes.length > nodeNow">
                {{ currentStage }} 
                <span class="countDown">{{ countDown.day }}</span>天
                <span class="countDown">{{ countDown.hours }}</span>时
                <span class="countDown">{{ countDown.minutes }}</span>分
                <span class="countDown">{{ countDown.seconds }}</span>秒
            </span>
            <span v-else>比赛已经结束</span>
        </div>
        <div class="stepBar">
            <el-steps :active="nodeNow" align-center
                finish-status="success" process-status="process"
            >
                <el-step v-for="node of nodes" :key="node[0]" 
                    :title="node[0]" :description="node[1]"
                ></el-step>
            </el-steps>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { formatTime } from '../utils.js'

export default {
    data() {
        return {
        }
    },
    computed: {
        ...mapState("$main", [ "nodes" ]),
        ...mapGetters("$main", [ "nodeNow", "next" ]),
        countDown() {
            if (this.next < 0) return {};
            const date = this.next;
            return {
                day: Math.floor(date / 86400),
                hours: formatTime(Math.floor(date / 3600) % 24),
                minutes: formatTime(Math.floor(date / 60) % 60),
                seconds: formatTime(date % 60)
            }
        },
        currentStage() {
            switch(this.nodeNow) {
                case 0: return "距离比赛开始还有"
                case 3: return "距离比赛结束还有" 
                default: return "距离进入下一阶段还有"
            }
        }
    },
}
</script>

<style lang="less" scoped>
.stepBar {
    padding: 30px 5px;
}
.countDownSpan {
    font-size: 16px;
}
.countDown {
    font-size: 32px;
    font-family: consolas;
    width: 31px;
}
</style>